import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFlagZ = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_1262_13428)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M0.566854 8.34788C0.19926 9.4995 0.000182015 10.7264 0.00022889 11.9999C0.000182015 13.2735 0.199307 14.5005 0.566901 15.6521L12.0002 16.1739L23.4336 15.6522C23.8011 14.5005 24.0003 13.2735 24.0003 12C24.0002 10.7264 23.8012 9.4995 23.4336 8.34783L12.0002 7.82611L0.566854 8.34788Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M23.4332 8.34783L11.9998 7.82611L0.56647 8.34783C0.457532 8.68927 0.363735 9.03741 0.285126 9.39131H23.7144C23.6359 9.03736 23.5421 8.68917 23.4332 8.34783Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0.285049 14.609C0.363565 14.9629 0.457362 15.311 0.566299 15.6524L0.567425 15.6525L11.9996 16.1742L23.4329 15.6525C23.5418 15.3111 23.6356 14.9629 23.7142 14.609H0.285049Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12.0004 24.0007C17.3543 24.0007 21.8885 20.4943 23.4337 15.6529H0.567108C2.11234 20.4943 6.64666 24.0007 12.0004 24.0007Z",
				fill: "#6DA544"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12.0001 -0.000793457C6.64629 -0.000746582 2.11207 3.50564 0.566742 8.34703L23.4334 8.34708C21.8882 3.5056 17.3539 -0.000840332 12.0001 -0.000793457Z",
				fill: "#338AF3"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.48348 4.9563C5.48348 3.83238 6.27337 2.89347 7.3282 2.66313C7.16611 2.62769 6.99787 2.60852 6.82509 2.60852C5.52843 2.60852 4.47726 3.65965 4.47726 4.95635C4.47726 6.25305 5.52834 7.30418 6.82509 7.30418C6.99787 7.30418 7.16606 7.28496 7.3282 7.24957C6.27342 7.01913 5.48348 6.08023 5.48348 4.9563Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.71538 6.02246L8.87429 6.5116H9.38861L8.97254 6.81395L9.13145 7.30309L8.71538 7.00079L8.29923 7.30309L8.45818 6.81395L8.04207 6.5116H8.55638L8.71538 6.02246Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10.3576 6.02246L10.5166 6.5116H11.0309L10.6148 6.81395L10.7737 7.30309L10.3576 7.00079L9.9415 7.30309L10.1004 6.81395L9.68439 6.5116H10.1987L10.3576 6.02246Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.9988 6.02246L12.1577 6.5116H12.672L12.2559 6.81395L12.4148 7.30309L11.9988 7.00079L11.5826 7.30309L11.7416 6.81395L11.3255 6.5116H11.8398L11.9988 6.02246Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M13.6409 6.02246L13.7998 6.5116H14.3141L13.898 6.81395L14.057 7.30309L13.6409 7.00079L13.2247 7.30309L13.3837 6.81395L12.9676 6.5116H13.4819L13.6409 6.02246Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M15.2822 6.02246L15.4412 6.5116H15.9555L15.5394 6.81395L15.6984 7.30309L15.2822 7.00079L14.8661 7.30309L15.0251 6.81395L14.609 6.5116H15.1233L15.2822 6.02246Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10.3576 4.31519L10.5166 4.80428H11.0309L10.6148 5.10667L10.7737 5.59577L10.3576 5.29347L9.9415 5.59577L10.1004 5.10667L9.68439 4.80428H10.1987L10.3576 4.31519Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.9988 4.31519L12.1577 4.80428H12.672L12.2559 5.10667L12.4148 5.59577L11.9988 5.29347L11.5826 5.59577L11.7416 5.10667L11.3255 4.80428H11.8398L11.9988 4.31519Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M13.6409 4.31519L13.7998 4.80428H14.3141L13.898 5.10667L14.057 5.59577L13.6409 5.29347L13.2247 5.59577L13.3837 5.10667L12.9676 4.80428H13.4819L13.6409 4.31519Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M15.2822 4.31519L15.4412 4.80428H15.9555L15.5394 5.10667L15.6984 5.59577L15.2822 5.29347L14.8661 5.59577L15.0251 5.10667L14.609 4.80428H15.1233L15.2822 4.31519Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.9988 2.60809L12.1577 3.09728H12.672L12.2559 3.39958L12.4148 3.88877L11.9988 3.58647L11.5826 3.88877L11.7416 3.39958L11.3255 3.09728H11.8398L11.9988 2.60809Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M13.6409 2.60809L13.7998 3.09728H14.3141L13.898 3.39958L14.057 3.88877L13.6409 3.58647L13.2247 3.88877L13.3837 3.39958L12.9676 3.09728H13.4819L13.6409 2.60809Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M15.2822 2.60809L15.4412 3.09728H15.9555L15.5394 3.39958L15.6984 3.88877L15.2822 3.58647L14.8661 3.88877L15.0251 3.39958L14.609 3.09728H15.1233L15.2822 2.60809Z",
				fill: "#F0F0F0"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_1262_13428",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgFlagZ;
